/**
 * The drawing of the panel's sign-in (DS-007): a grid of streets, vehicles and one trip that follows
 * the streets from its pickup to its destination, in thin lines of the text color over the tenant's
 * brand. Pure decoration: it says nothing a screen reader needs, carries no image and follows the
 * brand and the theme.
 */
export function AuthMotif() {
  return (
    <svg className="auth-motif" viewBox="0 0 640 800" preserveAspectRatio="xMidYMid slice" aria-hidden focusable="false">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        {/* streets and one avenue across */}
        <g strokeWidth={1.5} opacity={0.16}>
          <path d="M-20 130 H660 M-20 300 H660 M-20 470 H660 M-20 640 H660" />
          <path d="M140 -20 V820 M330 -20 V820 M520 -20 V820" />
          <path d="M-20 780 L660 60" strokeWidth={6} />
        </g>
        {/* the trip: pickup → along the streets → destination */}
        <path d="M140 300 H318 Q330 300 330 312 V458 Q330 470 342 470 H520" strokeWidth={3} opacity={0.95} />
        <circle cx={140} cy={300} r={12} strokeWidth={2.5} opacity={0.95} />
      </g>
      <g fill="currentColor">
        <circle cx={140} cy={300} r={4.5} />
        <circle cx={520} cy={470} r={7} />
        {/* vehicles nearby */}
        <g opacity={0.5}>
          <circle cx={236} cy={130} r={4} />
          <circle cx={520} cy={208} r={4} />
          <circle cx={140} cy={560} r={4} />
          <circle cx={430} cy={640} r={4} />
          <circle cx={330} cy={720} r={4} />
          <circle cx={600} cy={300} r={4} />
          <circle cx={60} cy={470} r={4} />
        </g>
      </g>
    </svg>
  );
}
